module.exports = __webpack_public_path__ + "static/media/jackpot-main-background.8342f056.png";